import React, { useState, useContext } from 'react';
import BigNumber from 'bignumber.js';

import { getAddress } from '../../../utils/commons';
import { approveNft } from '../../../blockchain/nft';

import { ToastContext } from '../../../context/toast';

const NftMergeCard = ({ nftData, ribbon = '', selected = false, disabled = false, toggleCardId, hideActions = false, from = 'nftMerge' }) => {
  const { addToast } = useContext(ToastContext);

  const [pendingTx, setPendingTx] = useState(false);

  const handleApprove = async () => {
    setPendingTx(true);
    let tx;
    try {
      tx = await approveNft(getAddress(from), nftData.pid);
      await tx.wait();
      addToast('Card Approve succeeded', 'is-success');
    } catch (error) {
      tx = { error: error.message };
    }

    if(tx?.error !== undefined) {
      console.log('error', tx.error);
      addToast('Card Approve failed', 'is-danger');
    }

    setPendingTx(false);
  }

  const renderActions = () => {
    if (from === 'nftMergeEndless' && new BigNumber(nftData.generation).eq(7)) {
      return;
    }

    if (from === 'nftMerge' && nftData.mergeCount > 0) {
      return (<p className="has-primary-text">Merged Card</p>);
    }

    if (nftData.busy) {
      return (<p className="has-primary-text">Busy Card</p>);
    }

    if (nftData.allowance !== getAddress(from)) {
      return (
        <button
          className={ `button is-primary is-fullwidth ${pendingTx ? 'is-loading' : ''}` }
          disabled={ pendingTx || disabled }
          onClick={ handleApprove }
        >
          Approve
        </button>
      );
    }

    return (
      <div className="field">
        <input
          id={ `pid-${nftData.pid}` }
          type="checkbox"
          name={ `pid-${nftData.pid}` }
          className="switch is-rounded is-outlined"
          checked={ selected }
          onChange={ () => toggleCardId(nftData.pid, nftData.generation) }
          disabled={ disabled && !selected }
        />
        <label htmlFor={ `pid-${nftData.pid}` }>Select</label>
      </div>
    );
  }

  const important = from === 'nftMerge' ? nftData.mergeCount > 0 : new BigNumber(nftData.generation).eq(7);

  return (
    <div className={ `box is-relative ${important ? 'important-box' : ''}` }>
      { ribbon !== '' ? (
        <div className="ribbon ribbon-top-right">
          <span>{ ribbon }</span>
        </div>
      ) : null }
      <p className="title is-size-4 neon-success is-hidden-desktop">{ nftData.name }</p>
      <p className="subtitle is-suze-6 has-text-danger is-hidden-desktop mb-1">Generation { nftData.generation }</p>
      <div className="columns is-mobile mb-0">
        <div className="column">
          <figure className="image is-4by5 mb-3">
            <img src={ `/images/nfts/generation-${nftData.generation}.png` } alt="Sandman" />
          </figure>
        </div>
        <div className="column">
          <p className="title is-size-4 neon-success is-hidden-mobile">{ nftData.name }</p>
          <p className="subtitle is-suze-6 has-text-danger is-hidden-mobile mb-3">Generation { nftData.generation }</p>
          <div className="tags is-fullwidth has-addons mb-1">
            <span className="tag mb-0 is-warning is-two-thirds">Strength</span>
            <span className="tag mb-0 is-danger is-one-third">{ nftData.strength }</span>
          </div>
          <div className="tags is-fullwidth has-addons mb-1">
            <span className="tag mb-0 is-warning is-two-thirds">Agility</span>
            <span className="tag mb-0 is-danger is-one-third">{ nftData.agility }</span>
          </div>
          <div className="tags is-fullwidth has-addons mb-1">
            <span className="tag mb-0 is-warning is-two-thirds">Endurance</span>
            <span className="tag mb-0 is-danger is-one-third">{ nftData.endurance }</span>
          </div>
          <div className="tags is-fullwidth has-addons mb-1">
            <span className="tag mb-0 is-warning is-two-thirds">Intelligence</span>
            <span className="tag mb-0 is-danger is-one-third">{ nftData.intelligence }</span>
          </div>
          <div className="tags is-fullwidth has-addons mb-1">
            <span className="tag mb-0 is-warning is-two-thirds">Magic</span>
            <span className="tag mb-0 is-danger is-one-third">{ nftData.magic }</span>
          </div>
          <div className="tags is-fullwidth has-addons mb-1">
            <span className="tag mb-0 is-warning is-two-thirds">Wisdom</span>
            <span className="tag mb-0 is-danger is-one-third">{ nftData.wisdom }</span>
          </div>
          <div className="tags is-fullwidth has-addons mb-1 is-hidden-mobile">
            <span className="tag mb-0 is-dark is-two-thirds">Exp.</span>
            <span className="tag mb-0 is-success is-one-third">{ new BigNumber(nftData.experience).toFormat(0) }</span>
          </div>
          <div className="tags is-fullwidth has-addons mb-1 is-hidden-mobile">
            <span className="tag mb-0 is-dark is-two-thirds">Boost Stake</span>
            <span className="tag mb-0 is-info is-one-third">{ new BigNumber(nftData.boostStake).toFormat(2) }%</span>
          </div>
        </div>
      </div>
      <div className="field is-grouped is-grouped-multiline is-hidden-desktop">
        <div className="control">
          <div className="tags has-addons">
            <span className="tag mb-0 is-dark">Exp.</span>
            <span className="tag mb-0 is-success">{ new BigNumber(nftData.experience).toFormat(0) }</span>
          </div>
        </div>
        <div className="control">
          <div className="tags has-addons">
            <span className="tag mb-0 is-dark">Boost Stake</span>
            <span className="tag mb-0 is-info">{ nftData.boostStake }%</span>
          </div>
        </div>
      </div>

      {hideActions ? null : (
        <div className="pt-3 has-text-centered">
          { renderActions() }
        </div>
      )}
    </div>
  );
}

export default NftMergeCard;
